import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	weekDayShortDayNumeric: {
		id: 'eoc-schedule-common.common.ui.timeline.layer.week-day-short-day-numeric',
		defaultMessage: '{weekDayShort} {dayNumeric}',
		description: 'Date render method for a day or a week. (e.g. MON 14, TUE 31)',
	},
});

export { messages };
